export default {
  version: '2.2.1',
  api: 'https://api.eyeson.team',
  allowSafariSFU: true,
  screencapture: true,
  verbose: true,
  vbgScriptPath: 'vendor/tflite/',
  hdCamera: true
};
